<template lang="pug">

    div.ui.basic.padded.segment(style="text-align: center")
        canvas(ref="confettiCanvas" style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; pointer-events: none; z-index: 2147483647;")
        button.ui.massive.primary.looping.pulsating.transition.button(v-on:click="release()" v-bind:disabled="isDisabled" v-bind:title="isDisabled ? 'Druckdaten müssen vollständig geprüft und freigegeben sein (Status: Freigabe-PDF bestätigt)' : ''")
            i.icon.send.md
            | BLAST! (Für Lieferanten freigeben)

</template>

<script>
    import * as R from "ramda";
    import confetti from "canvas-confetti";
    let myConfetti = null;

    export default {

        computed: {
            isDisabled() {
                return this.productModel.printingDataStatus !== 'FORM_PROOF_CONFIRMED'
            }
        },

        methods: {

            fireConfetti() {
                if (!myConfetti) {
                    myConfetti = confetti.create(this.$refs.confettiCanvas, { resize: true, useWorker: false });
                }
                myConfetti({
                    particleCount: 150,
                    spread: 80,
                    origin: { y: 0.6 }
                });
            },

            async release() {
                if (!await this.$growl.confirm("Angebot für Lieferanten freigeben?")) {
                    return
                }

                // Model erstellen
                const model = R.assoc('status', 'ACCEPTED', this.jobModel)

                try {
                    // Preis speichern
                    await this.$store.dispatch("jobs/update", { id: model.id, model })

                    // Erfolgsmeldung anzeigen
                    this.$growl.success("Angebot wurde für Lieferanten freigegeben")

                    // Konfetti nach DOM-Update abspielen (nach dem Toast-Rendering)
                    this.$nextTick(() => this.fireConfetti())

                } catch (e) {
                    // ggf. Fehlermeldung anzeigen
                    this.$growl.fatal("Angebot konnte nicht freigegeben werden", e)
                }

            }

        },

        props: {

            jobModel: {
                type: Object,
                required: true
            },

            productModel: {
                type: Object,
                required: true
            }

        }

    }

</script>
